/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
// import AddFavorite from './AddFavorite';

class ProductLightbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusImg: '',
      images: [],
    };
  }

  componentDidMount() {
    const {
      product: {
        imageInfo: { images },
      },
    } = this.props;

    this.setState({ images, focusImg: images && images.length > 0 ? images[0] : '' });
  }

  handleLBImg = (e) => {
    console.log(e.target.src);
    this.setState({ focusImg: e.target.src });
  };

  render() {
    // const {
    //   product: {
    //     // imageInfo: { images },
    //     rightTextInfo,
    //   },
    // } = this.props;
    const { images, focusImg } = this.state;

    return (
      <>
        <div className="product__container-lightbox row">
          <div className="product__img-lightbox-focus mb-3 col-12">
            <img alt="" className="img-fluid" src={`${focusImg}?${Math.random()}`} />
          </div>
          <div
            id="lighbox-nav"
            className="d-flex product__img-lightbox-thumbs col-md-8 mb-3 mb-md-0"
          >
            {images
              && images.length > 0
              && images.map((item) => (
                <img
                  alt=""
                  className={`img-fluid product__img-lightbox-thumb ${
                    focusImg && focusImg.indexOf(item) !== -1 ? 'active' : ''
                  }`}
                  key={item}
                  src={item}
                  onClick={this.handleLBImg}
                  onKeyDown={() => {}}
                />
              ))}
          </div>
          {/* 加入最愛 btn */}
          {/* <AddFavorite
            {...this.props}
            className="col-4 d-none d-md-flex"
            isTracking={rightTextInfo.isTracking}
          /> */}
        </div>
      </>
    );
  }
}
export default ProductLightbox;
